import type { DbFrameworkPack } from "./frameworkPackDb.ts";

export const MAX_PACK_SALIENCE_BOOST_MULTIPLIER = 2.5;

/** Returns signal IDs whose positiveIndicators appear in the text */
export function detectNoticingSignals(
  text: string,
  pack: DbFrameworkPack | null,
): string[] {
  if (!pack) return [];
  const lower = text.toLowerCase();
  return pack.noticingSignals
    .filter((signal) =>
      signal.positiveIndicators.some((indicator) => lower.includes(indicator.toLowerCase()))
    )
    .map((signal) => signal.id);
}

/**
 * Boosts a base evidence score by the pack's salience weights
 * for any signals detected in the evidence text.
 * Caps at MAX_BOOST_MULTIPLIER × base.
 */
export function applyPackSalienceBoost(
  baseScore: number,
  evidenceText: string,
  pack: DbFrameworkPack | null,
): number {
  if (!pack || baseScore === 0) return baseScore;

  const matchedSignals = detectNoticingSignals(evidenceText, pack);
  if (matchedSignals.length === 0) return baseScore;

  const totalBoost = matchedSignals.reduce((sum, signalId) => {
    return sum + (pack.salienceWeights[signalId] ?? 1);
  }, 0);

  const avgBoost = totalBoost / matchedSignals.length;
  return baseScore * Math.min(avgBoost, MAX_PACK_SALIENCE_BOOST_MULTIPLIER);
}
